import { render, staticRenderFns } from "./TerminalsInquiriesTable.vue?vue&type=template&id=06db3e5c&scoped=true&lang=pug&"
import script from "./TerminalsInquiriesTable.vue?vue&type=script&lang=js&"
export * from "./TerminalsInquiriesTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminalsInquiriesTable.vue?vue&type=style&index=0&id=06db3e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db3e5c",
  null
  
)

export default component.exports